/**
 * Custom hook to dispatch events to Google Tag Manager
 * @returns trackEvent function to dispatch events
 */
export default function useGTMDispatch() {
  return (obj: object) => {
    if (typeof window !== "undefined") {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj);
    }
  };
}
